import React, { useEffect, useRef, useState } from "react";
import copyIcon from "../../assets/copy.svg";
import exportIcon from "../../assets/export.svg";
import backlogIcon from "../../assets/backlog.svg";
import archiveIcon from "../../assets/archive.svg";
import { ReactComponent as UserLogo } from "../../assets/user-icon-color.svg";
import { ReactComponent as EditLogo } from "../../assets/edit-icon-color.svg";
import { ReactComponent as ImageLogo } from "../../assets/image-icon-color.svg";
import { ReactComponent as DeleteLogo } from "../../assets/delete-icon-color.svg";
import { ReactComponent as ArchiveLogo } from "../../assets/archive-color.svg";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import "./ProjectSharePopup.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import useIsMobile from "../../hooks/useIsMobile";
import { useNavigate } from "react-router";
import { generateShareLink } from "../../store/usersSlice";

const ACCESS_OPTIONS = [
  { value: "VIEWER", label: "для просмотра" },
  { value: "COMMENTER", label: "для комментирования" },
  { value: "ADMIN", label: "для редактирования" },
];

const ProjectSharePopup = ({
  project,
  versionId = null,
  onClose = () => {},
  onOpenTeamScreen = () => {},
  onOpenBacklog,
  onRename = () => {},
  onChangeCover = () => {},
  onDelete = () => {},
  onArchive = () => {},
  className = "",
  isModal = false,
}) => {
  const popupRef = useRef();
  const [access, setAccess] = useState("VIEWER");
  const [comment, setComment] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [linkLoading, setLinkLoading] = useState(true);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    dispatch(
      generateShareLink({
        resourceId: versionId ? versionId : project.id,
        resourceType: versionId ? "VIDEO" : "PROJECT",
        role: access,
      })
    ).then((res) => {
      if (!res.error) {
        setShareLink(res.payload);
      }
    });
  }, [access]);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleChangeEmailValue = (value) => {
    if (shareLink) {
      setShareLink("");
    }
    setEmailValue(value.trim());
    // clearTimeout(updateCommentTimeout.current);
    // if (validateEmail(value)) {
    //   updateCommentTimeout.current = setTimeout(() => {
    //     dispatch(
    //       generateShareLink({
    //         resourceId: video.id,
    //         resourceType: "VIDEO",
    //         role: access,
    //         email: value,
    //       })
    //     ).then((res) => {
    //       if (!res.error) {
    //         setShareLink(res.payload);
    //       }
    //     });
    // }, 1000);
    // }
  };

  const handleInviteSharedUser = () => {
    dispatch(
      generateShareLink({
        resourceId: project.id,
        resourceType: "PROJECT",
        role: access,
        email: emailValue,
      })
    ).then((res) => {
      if (!res.error) {
        setShareLink(res.payload);
        navigator.clipboard.writeText(res.payload);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    });
  };

  return (
    <div
      ref={popupRef}
      className={`project-share-popup-context-menu ${className}`}
    >
      <div className="project-share-popup-row project-share-popup-link-row">
        <span className="project-share-popup-label">Поделиться ссылкой</span>
        <div className="project-share-popup-access-select">
          {false ? (
            <div
              style={{
                width: 200,
                paddingTop: 6,
                borderRadius: 4,
                paddingBottom: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
                color: "#333B4B",
                fontSize: 14,
                fontWeight: 500,
                fontFamily: "NT Somic",
              }}
            >
              Скопирована
            </div>
          ) : (
            <select value={access} onChange={(e) => setAccess(e.target.value)}>
              {ACCESS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      {access === "VIEWER" && (
        <div className="project-share-popup-row">
          <input
            className="project-share-popup-link-input"
            style={{ background: "#14263e" }}
            value={shareLink}
            readOnly
            placeholder="Загрузка..."
          />
          <button className="project-share-popup-copy-btn" onClick={handleCopy}>
            <img src={copyIcon} alt="copy" style={{ width: 18, height: 18 }} />
          </button>
        </div>
      )}
      {copied && access === "VIEWER" && (
        <span className="project-share-popup-copied">
          {"Ссылка скопирована в буфер!"}
        </span>
      )}
      {access !== "VIEWER" && (
        <span
          style={{
            display: "block",
            textAlign: "left",
            color: "#6e7986",
            fontSize: 14,
            lineHeight: 1,
            marginBottom: 16,
          }}
        >
          Введите почту пользователя, чтобы расшарить видео с возможностью{" "}
          {access === "COMMENTER" ? "комментирования" : "редактирования"}
        </span>
      )}
      {access !== "VIEWER" && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            marginBottom: 12,
          }}
        >
          <input
            className="share-popup-email"
            placeholder="Электронная почта"
            style={{
              marginBottom: 0,
              minHeight: 18,
              background: "#152c4e",
              borderColor: "#4056d0",
            }}
            value={emailValue}
            onChange={(e) => {
              handleChangeEmailValue(e.target.value);
            }}
          />
          <PrimaryButton
            onClick={() => {
              handleInviteSharedUser();
            }}
            isLoading={false}
            text={"Пригласить"}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              borderRadius: 8,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      )}
      {copied && access !== "VIEWER" && (
        <span className="project-share-popup-copied">
          {"Ссылка скопирована в буфер!"}
        </span>
      )}
      {(!isModal && (
        <>
          <textarea
            className="project-share-popup-comment"
            placeholder={t("Комментарий к проекту (доступен всем по ссылке)")}
            value={comment}
            style={{ background: "#101928" }}
            onChange={(e) => setComment(e.target.value)}
          />
          <div className="project-share-popup-actions">
            <button
              className="project-share-popup-action"
              onClick={() => onOpenTeamScreen()}
            >
              <UserLogo style={{ marginRight: 5 }} />
              {"Команда"}
            </button>
            {/* <button
          className="project-share-popup-action"
          onClick={() => {
            if (onClose) onClose();
            if (onOpenBacklog) onOpenBacklog();
          }}
        >
          <img src={backlogIcon} alt="backlog" /> {t("share.folderBacklog")}
        </button> */}
            <button
              className="project-share-popup-action"
              onClick={(e) => onRename(e)}
            >
              <EditLogo style={{ marginRight: 5 }} />
              {t("share.renameFolder")}
            </button>
            <button
              className="project-share-popup-action"
              onClick={(e) => onChangeCover(e)}
            >
              <ImageLogo style={{ marginRight: 5 }} /> {t("share.changeCover")}
            </button>
            <button
              className="project-share-popup-action"
              onClick={(e) => onArchive(project.id, e)}
            >
              <ArchiveLogo style={{ marginRight: 5 }} /> {t("share.archive")}
            </button>
            <button
              className="project-share-popup-action"
              onClick={(e) => onDelete(project.id, e)}
            >
              <DeleteLogo style={{ marginRight: 5 }} /> {t("share.delete")}
            </button>
          </div>
        </>
      )) ||
        null}
    </div>
  );
};

export default ProjectSharePopup;
